import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { ListingPropertyTypeProperties } from "../types/listingPropertyType.type";
import { useEffect } from "react";
import { httpRequest } from "../helpers/api";
import { BaseResponsePaginationProps } from "../types/config.type";
import { message } from "antd";
import { getErrorMessage } from "../helpers/errorHandler";

type State = {
	lastUpdatedAt?: string | Date | null;
	propertyTypes: ListingPropertyTypeProperties[];
	setPropertyTypes: React.Dispatch<ListingPropertyTypeProperties[]>;
	setLastUpdatedAt: (v: string | Date | null) => void;
};

const usePropertyTypes = create(
	persist<State>(
		(set) => ({
			lastUpdatedAt: null,
			propertyTypes: [],
			setPropertyTypes: (v: ListingPropertyTypeProperties[]) => {
				set((state) => ({
					propertyTypes: v,
				}));
			},
			setLastUpdatedAt: (v) => set({ lastUpdatedAt: v }),
		}),
		{
			name: "property-types", // Name for the storage key
			storage: createJSONStorage(() => localStorage),
		}
	)
);

function useInitPropertyTypes() {
	const { lastUpdatedAt, setPropertyTypes, setLastUpdatedAt } = usePropertyTypes();

	const isExpired = () => {
		if (!lastUpdatedAt) return true; // kalau null langsung dianggap expired

		const last = new Date(lastUpdatedAt).getTime();
		const now = Date.now();

		const diff = now - last;
		return diff > 24 * 60 * 60 * 1000; // 24 jam
	};

	useEffect(() => {
		const check = async () => {
			const shouldFetch = !lastUpdatedAt || isExpired();

			if (shouldFetch) {
				try {
					let { data } = await httpRequest.get<BaseResponsePaginationProps<ListingPropertyTypeProperties>>(
						"/listing-property-types?limit=1000&sort=name:ASC&filterIsPublished=true"
					);
					const sortedType = data.payload.results.sort((a, b) => a.name.localeCompare(b.name, "id"));

					setPropertyTypes(sortedType);
					setLastUpdatedAt(new Date().toISOString());
				} catch (error) {
					message.error(getErrorMessage(error));
				}
			}
		};

		check();
	}, []);
}

export { usePropertyTypes, useInitPropertyTypes };
